<template>
  <v-container fluid fill-height>
    <v-flex sm12>

      <!-- FILTROS -->
      <v-toolbar
        color="#eee"
        class="elevation-0 secondary--text mb-4"
        style="background: transparent"
      >
        <v-layout
          row
          wrap
          justify-center
          align-center
          class="filtros"
        >

          <!-- Título -->
          <v-flex
            xs12
            sm2
            class="filtro-titulo"
          >
            <v-toolbar-title>
              Convênio
            </v-toolbar-title>
          </v-flex>

          <!-- Código -->
          <v-flex
            xs12
            sm2
            class="filtro-item"
          >
            <v-text-field
              v-model="filtroCodigo"
              label="Buscar por Código"
              prepend-icon="search"
              clearable
              hide-details
            ></v-text-field>
          </v-flex>

          <!-- Usuário -->
          <v-flex
            xs12
            sm2
            class="filtro-item"
          >
            <v-text-field
              v-model="filtroUsuario"
              label="ID do Usuário"
              prepend-icon="person"
              clearable
              hide-details
            ></v-text-field>
          </v-flex>

          <!-- Data -->
          <v-flex
            xs12
            sm3
            class="filtro-item"
          >
            <v-menu
              ref="menuData"
              v-model="menuData"
              :close-on-content-click="false"
              lazy
              transition="slide-y-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataSelecionada"
                  label="Data"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  clearable
                  hide-details
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="dataSelecionada"
                locale="pt-br"
                color="info"
                @input="menuData = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <!-- Status -->
          <v-flex
            xs12
            sm3
            class="filtro-item"
          >
            <v-select
              v-model="filtroStatus"
              :items="statusOptions"
              label="Status"
              hide-details
            ></v-select>
          </v-flex>

        </v-layout>
      </v-toolbar>

      <!-- VOUCHERS -->
      <div>
        <v-layout
          row
          wrap
          justify-space-between
          v-if="
            historyConvenioVouchers &&
            historyConvenioVouchers.results &&
            historyConvenioVouchers.results.length > 0
          "
        >

          <v-flex
            v-for="(voucher, index) in historyConvenioVouchers.results"
            :key="index"
            md5
            xs12
          >
            <v-card class="voucher-card mb-3 elevation-2">

              <v-layout
                row
                wrap
                align-center
              >

                <!-- Ícone -->
                <v-flex
                  xs2
                  sm2
                  class="text-xs-center"
                >
                  <v-avatar
                    size="45"
                    color="grey lighten-2"
                  >
                    <v-icon
                      size="30"
                      color="grey darken-2"
                    >
                      local_offer
                    </v-icon>
                  </v-avatar>
                </v-flex>

                <!-- Informações -->
                <v-flex
                  xs10
                  sm10
                  class="voucher-content"
                >

                  <!-- Código -->
                  <div class="voucher-codigo primary--text">
                    Voucher Convênio: {{ voucher.codigo }}
                  </div>

                  <!-- Desconto -->
                  <div class="voucher-desconto">
                    <span>Desconto:</span>

                    <strong
                      v-if="voucher.percentual_desconto"
                      class="primary--text"
                    >
                      {{ voucher.percentual_desconto }}%
                    </strong>
                  </div>

                  <!-- Data -->
                  <div class="voucher-info">
                    <span>Gerado em:</span>
                    {{ formatarData(voucher.data_gerado) }}
                    às
                    {{ formatarHora(voucher.hora_gerado) }}
                  </div>

                  <!-- Valores -->
                  <div
                    v-if="voucher.valor_final !== undefined"
                    class="voucher-info mt-1"
                  >
                    <span>Valor a Pagar:</span>
                    <strong class="success--text" style="font-size: 1.1em;">R$ {{ parseFloat(voucher.valor_final).toFixed(2).replace('.', ',') }}</strong>
                  </div>

                  <!-- Cliente -->
                  <div
                    v-if="voucher.usuario_beneficiado"
                    class="voucher-info"
                  >
                    <span>Cliente:</span>

                    {{
                      voucher.usuario_beneficiado.id_cliente ||
                      voucher.usuario_beneficiado.id
                    }}

                    <template
                      v-if="voucher.usuario_beneficiado.pessoa"
                    >
                      -
                      {{
                        voucher.usuario_beneficiado.pessoa.nome_completo ||
                        voucher.usuario_beneficiado.pessoa.nome
                      }}
                    </template>
                  </div>

                  <!-- Status -->
                  <div
                    class="voucher-status"
                    :class="
                      voucher.disponivel
                        ? 'success--text'
                        : 'error--text'
                    "
                  >
                    {{
                      voucher.disponivel
                        ? 'Disponível'
                        : 'Utilizado/Inativo'
                    }}
                  </div>

                  <!-- Inativado -->
                  <div
                    v-if="
                      !voucher.disponivel &&
                      voucher.data_inativado
                    "
                    class="voucher-info"
                  >
                    <span>Inativado em:</span>
                    {{ formatarData(voucher.data_inativado) }}
                    às
                    {{ formatarHora(voucher.hora_inativado) }}
                  </div>

                </v-flex>
              </v-layout>

              <!-- Ações -->
              <v-card-actions class="voucher-actions">

                <!-- Detalhes -->
                <v-btn
                  flat
                  small
                  color="primary"
                  @click="abrirDialog(voucher, 'detalhes')"
                >
                  Detalhes
                </v-btn>

                <!-- Ler -->
                <v-btn
                  v-if="voucher.disponivel"
                  flat
                  small
                  color="success"
                  @click="abrirDialog(voucher, 'leitura')"
                >
                  Ler
                </v-btn>

              </v-card-actions>

            </v-card>
          </v-flex>

        </v-layout>

        <!-- Nenhum voucher -->
        <h2
          v-else
          class="text-xs-center primary--text mt-5"
        >
          NENHUM VOUCHER ENCONTRADO
        </h2>

        <!-- Paginação -->
        <div class="text-xs-center mt-3">
          <v-pagination
            v-model="pagination.page"
            :length="pages"
            circle
          ></v-pagination>
        </div>

        <!-- DIALOG -->
        <v-dialog
          v-model="dialogAberto"
          persistent
          max-width="700px"
        >
          <detalhes-convenio
            v-if="voucherSelecionado"
            :voucher="voucherSelecionado"
            :modo="modoDialog"
            :loading="loadingVoucher"
            @fechar="fecharDialog"
            @ler="utilizarVoucher"
          />
        </v-dialog>

      </div>
    </v-flex>
  </v-container>
</template>

<script>
import DetalhesConvenio from '@/components/dialogs/DetalhesConvenio'

export default {
  components: {
    DetalhesConvenio
  },

  data: () => ({
    pagination: {
      rowsPerPage: 10,
      page: 1
    },

    filtroCodigo: null,
    filtroUsuario: null,
    filtroStatus: 'todos',
    statusOptions: [
      { text: 'Todos', value: 'todos' },
      { text: 'Não Lidos', value: 'nao_lidos' },
      { text: 'Lidos', value: 'lidos' }
    ],
    dataSelecionada: null,
    menuData: false,

    timeoutUsuario: null,

    dialogAberto: false,
    modoDialog: 'detalhes',
    voucherSelecionado: null,
    loadingVoucher: false
  }),

  computed: {
    pages () {
      const count = this.historyConvenioVouchers
        ? this.historyConvenioVouchers.count
        : 0

      if (
        this.pagination.rowsPerPage == null ||
        count == null ||
        count === 0
      ) {
        return 0
      }

      return Math.ceil(
        count / this.pagination.rowsPerPage
      )
    },

    historyConvenioVouchers () {
      return this.$store.getters.historyConvenioVouchers
    },

    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },

    frentistaLogado () {
      return this.$store.state.user
        ? this.$store.state.user.frentista
        : null
    }
  },

  watch: {
    'pagination.page': {
      handler () {
        this.carregarVouchers()
      },
      deep: true
    },

    dataSelecionada () {
      this.pagination.page = 1
      this.carregarVouchers()
    },

    filtroStatus () {
      this.pagination.page = 1
      this.carregarVouchers()
    },

    filtroUsuario () {
      clearTimeout(this.timeoutUsuario)

      this.timeoutUsuario = setTimeout(() => {
        this.pagination.page = 1
        this.carregarVouchers()
      }, 500)
    },

    filtroCodigo () {
      clearTimeout(this.timeoutUsuario)

      this.timeoutUsuario = setTimeout(() => {
        this.pagination.page = 1
        this.carregarVouchers()
      }, 500)
    }
  },

  mounted () {
    const dataAtual = new Date()

    const mes = (dataAtual.getMonth() + 1)
      .toString()
      .padStart(2, '0')

    const ano = dataAtual.getFullYear()

    const dia = dataAtual.getDate()
      .toString()
      .padStart(2, '0')

    this.dataSelecionada = `${ano}-${mes}-${dia}`

    this.carregarVouchers()
  },

  methods: {
    carregarVouchers () {
      const data = {
        page: this.pagination.page
      }

      if (this.dataSelecionada) {
        data.data_gerado = this.dataSelecionada
      }

      if (this.filtroUsuario) {
        data.usuario_beneficiado = this.filtroUsuario
      }

      if (this.filtroStatus !== 'todos') {
        data.disponivel = this.filtroStatus === 'nao_lidos' ? 'True' : 'False'
      }

      if (this.filtroCodigo) {
        data.codigo__icontains = this.filtroCodigo
      }

      this.$store.dispatch(
        'carregarHistoryConvenioVouchers',
        data
      )
    },

    formatarData (dataIso) {
      if (!dataIso) return ''

      const partes = dataIso.split('-')

      if (partes.length !== 3) {
        return dataIso
      }

      return `${partes[2]}/${partes[1]}/${partes[0]}`
    },

    formatarHora (hora) {
      if (!hora) return ''

      const valor = String(hora)

      const match = valor.match(
        /(\d{2}:\d{2}:\d{2})/
      )

      return match ? match[1] : valor
    },

    abrirDialog (voucher, modo) {
      this.voucherSelecionado = voucher
      this.modoDialog = modo
      this.dialogAberto = true
    },

    fecharDialog () {
      this.dialogAberto = false
      this.voucherSelecionado = null
    },

    utilizarVoucher () {
      this.loadingVoucher = true

      this.$store.dispatch(
        'utilizarVoucherConvenio',
        {
          idVoucher:
            this.voucherSelecionado.id_voucher_desconto,
          senha: ''
        }
      )
        .then(() => {
          this.loadingVoucher = false

          this.fecharDialog()
          this.carregarVouchers()

          this.$store.commit('setSuccess', {
            message:
              'Voucher de convênio utilizado com sucesso!',
            title: 'Sucesso'
          })
        })
        .catch((err) => {
          this.$store.dispatch('setError', {
            message:
              err.message ||
              'Erro ao utilizar voucher.'
          })
        })
        .finally(() => {
          this.loadingVoucher = false
        })
    },

    copyCodigo (codigo) {
      navigator.clipboard.writeText(codigo)
      alert('Código copiado: ' + codigo)
    }
  }
}
</script>

<style scoped>
.filtros {
  width: 100%;
}

.filtro-titulo {
  display: flex;
  align-items: center;
}

.filtro-item {
  padding: 0 8px;
}

.voucher-card {
  padding: 14px;
}

.voucher-content {
  padding-left: 8px;
}

.voucher-codigo {
  font-size: 1.05em;
  font-weight: 700;
  margin-bottom: 5px;
}

.voucher-desconto {
  font-size: 0.9em;
  margin-bottom: 4px;
}

.voucher-desconto span,
.voucher-info span {
  font-weight: 600;
}

.voucher-info {
  color: #555;
  font-size: 0.82em;
  line-height: 1.45;
  margin-bottom: 2px;
}

.voucher-status {
  font-size: 0.82em;
  font-weight: 700;
  margin-top: 5px;
}

.voucher-actions {
  padding: 8px 0 0;
}

@media (max-width: 959px) {
  .filtro-titulo {
    margin-bottom: 8px;
  }

  .filtro-item {
    padding: 0 6px;
  }
}

@media (max-width: 599px) {
  /* Filtros */
  .filtros {
    margin-top: 0 !important;
  }

  .filtro-titulo {
    justify-content: center;
    margin-bottom: 5px;
  }

  .filtro-item {
    padding: 4px 12px;
  }

  /* Cards */
  .voucher-card {
    padding: 12px;
  }

  .voucher-content {
    padding-left: 4px;
  }

  .voucher-codigo {
    font-size: 1em;
  }

  .voucher-info,
  .voucher-status {
    font-size: 0.8em;
  }

  .voucher-actions {
    padding-top: 5px;
  }
}

@media (max-width: 380px) {
  .filtro-item {
    padding: 3px 8px;
  }

  .voucher-card {
    padding: 10px;
  }

  .voucher-codigo {
    font-size: 0.95em;
  }

  .voucher-info,
  .voucher-status {
    font-size: 0.76em;
  }
}
</style>
